import React from 'react';
import { connect } from 'react-redux';
import { isStubImage } from '../../../helpers/ImageURL';

const uploadableEntities = ['imprints', 'artists', 'products'];

class EntityLogo extends React.Component {

    constructor(props) {
        super(props);
        this.openUploadRequest = this.openUploadRequest.bind(this);
    }

    openUploadRequest(e) {
        e.stopPropagation();
        const { item, onUploadRequest } = this.props;
        if(typeof onUploadRequest === 'function')
            onUploadRequest(item);
    }

    isAdmin() {
        const { user } = this.props;
        return !!(user && user.loggedIn && user.user && user.user.allow_admin);
    }

    isUploadable() {
        const { item, entity, externalLinks } = this.props;
        if(externalLinks === false)
            return false;
        if(!uploadableEntities.includes(entity))
            return false;
        if(!this.isAdmin())
            return false;
        if(!item || !item.id)
            return false;
        if(item.hasArtwork)
            return false;
        return !item.image || isStubImage(item.image, entity);
    }

    render() {
        const { item, entity } = this.props,
            logo = <div className="logo" style={{ backgroundImage: `url(${item.image})` }} />;

        if(!this.isUploadable()) {
            if(entity == 'playlists')
                return <a href={`/playlists/${item.id}/details`}>{logo}</a>;
            return <a href={`/${entity}/${item.id}`}>{logo}</a>;
        }

        return <div onClick={this.openUploadRequest}
            title="Stub artwork - click to upload"
            style={{ cursor: 'pointer' }}>
            {logo}
        </div>;
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps)(EntityLogo);
